import React from 'react';
import ReactSlider, { ReactSliderProps } from 'react-slider';
import styled from 'styled-components';
import { themeGet } from 'styled-system';

import { getStyledSystemProps } from 'src/helpers';
import { Label, LabelProps } from './Label';

export type SliderProps = LabelProps &
  ReactSliderProps & {
    color?: string;
  };
export const Slider = ({ color, label, value = 0, ...props }: SliderProps) => {
  const [styledProps, restProps] = getStyledSystemProps(props);
  return (
    <Label label={label} {...styledProps}>
      <StyledSlider
        value={Array.isArray(value) ? value : Number(value)}
        renderTrack={(trackProps, state) => Track({ ...trackProps, color }, state)}
        renderThumb={(thumbProps, state) => Thumb({ ...thumbProps, color }, state)}
        {...restProps}
      />
    </Label>
  );
};

Slider.defaultProps = {
  color: 'primary'
};

const Track = (props, state) => <StyledTrack {...props} index={state.index} />;

const Thumb = (props, state) => (
  <StyledThumb {...props}>
    <StyledTooltip>{state.valueNow}</StyledTooltip>
  </StyledThumb>
);

const StyledTooltip = styled.div`
  position: absolute;
  top: -35px;
  left: 50%;
  transform: translateX(-50%);
  padding: 7px 15px;
  display: none;
  font-size: 12px;
  background-color: ${themeGet('colors.textPrimary')};
  border-radius: 2px;
  color: ${themeGet('colors.white')};
  &:after {
    content: '';
    border-top: 6px solid ${themeGet('colors.textPrimary')};
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    left: 50%;
    position: absolute;
    bottom: -5px;
    transform: translateX(-50%);
  }
`;

const StyledSlider = styled(ReactSlider)`
  padding: 5px 0;
  width: 100%;
  cursor: pointer;

  &:hover {
    ${StyledTooltip} {
      display: block;
    }
  }
`;

const StyledTrack = styled.div`
  top: 50%;
  transform: translateY(-50%);
  height: 4px;
  background: ${props => (props.index === 1 ? themeGet('colors.cloudyBlueTwo') : themeGet('colors.' + props.color))};
  border-radius: 20px;
`;

const StyledThumb = styled.div<{ color?: string }>`
  top: 50%;
  transform: translateY(-50%);
  height: 12px;
  width: 12px;
  line-height: 12px;
  text-align: center;
  background-color: ${themeGet('colors.white')};
  border: 1px solid ${themeGet('colors.cloudyBlueTwo')};
  border-radius: 50%;
  color: ${themeGet('colors.white')};
  cursor: grab;
  outline: none;
`;
